import React, { FC, useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { DOM_ID } from '@UILayer/UILayer.types';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';

// STYLES
import style from '@UILayer/UILayer.scss';

// IMAGES
import warningIcon from './warning_icon.svg';
import { getCasinoMenu, getPopClient } from '@Managers/Redux/AppState/AppState';
import { Button } from '@UILayer/Inputs/Button';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { EDelegatedPages } from '@Managers/PopClient/UsePopClient.types';
import { TPopClientFeatures } from '@ConfigLoader/Configs';

import { CASINO_MENU_ITEM_DEFAULT, TCasinoMenuItem } from '@Managers/Redux/AppState/AppState.types';

export const MessageInsufficientFunds: FC<{ onClose: Function }> = ({ onClose }) => {
    const [state, setState] = useReducer((state: TCasinoMenuItem, newState: any) => ({ ...state, ...newState }), CASINO_MENU_ITEM_DEFAULT);

    useEffect(() => {}, []);
    const casinoData = useAppSelector(getCasinoMenu);
    const popClientconfig = useAppSelector(getPopClient);
    const { t } = useTranslation();

    function cashierAction() {
        const popClient = popClientconfig.enabled;
        const available = popClientconfig.supportedFeatures[TPopClientFeatures.OPEN_PAGE]?.delegatePages?.includes(EDelegatedPages.DEPOSIT) ? true : false;

        if (popClient && available) {
            EventsCenter.emit(EGameEvents.OPEN_PAGE, {
                pageID: EDelegatedPages.DEPOSIT,
                url: state.url
            });
        } else {
            window.open(state.url, '_blank');
        }
    }

    function closeWindow() {
        onClose();
    }

    useEffect(() => {
        if (casinoData && casinoData.cashier) {
            setState({ url: casinoData.cashier.url, title: casinoData.cashier.title, active: true });
        }
    }, [casinoData]);

    return (
        <>
            <div className={`${style.message_icon} ${style.message_icon_error}`}>
                <img src={warningIcon} alt="" />
            </div>
            <div className={style.message_header}></div>
            <div className={style.message_desc}>{t('POPUP_MESSAGE_INSUFFICIENTFUNDS_MESSAGE')}</div>
            <div className={style.message_actions}>
                <Button
                    id={DOM_ID.BUTTON_POPUP_MESSAGE_UNIFICIENT_FUNDS_ACCEPT}
                    description={t(`POPUP_MESSAGE_INSUFFICIENTFUNDS_ACCEPT_BUTTON_WCA_DESCRIPTION`)}
                    className={cn(style.popup_btn, style.green_btn)}
                    onChange={() => closeWindow()}
                    dataDismiss="modal"
                >
                    {t('OK')}
                </Button>
                {state.active && (
                    <Button
                        id={DOM_ID.BUTTON_POPUP_MESSAGE_UNIFICIENT_FUNDS_CASHIER}
                        description={t(`POPUP_MESSAGE_INSUFFICIENTFUNDS_CASHIER_BUTTON_WCA_DESCRIPTION`)}
                        className={cn(style.popup_btn, style.gold_btn)}
                        onChange={() => cashierAction()}
                        dataDismiss="modal"
                    >
                        {t('CASHIER')}
                    </Button>
                )}
            </div>
        </>
    );
};
